/*----------訂閱制頁面----------*/
let Subscription = [
  /*---課程 Start---*/
  {
    path: '/LessonDetailSubscription',
    name: 'LessonDetailSubscription',
    component: () => import('@/views/php/Subscription/LessonDetailSubscription.vue')
  },
  {
    path: '/VideoPlayerSubscription',
    name: 'VideoPlayerSubscription',
    component: () => import('@/views/php/Subscription/VideoPlayerSubscription.vue')
  },
  /*---課程 Start---*/
  /*---電子書 Start---*/
  {
    path: '/EbookLessonSubscription',
    name: 'EbookLessonSubscription',
    component: () => import('@/views/php/Subscription/EbookLessonSubscription.vue')
  },
  {
    path: '/EbookKnowledgeArchitectureSubscription',
    name: 'EbookKnowledgeArchitectureSubscription',
    component: () => import('@/views/php/Subscription/EbookKnowledgeArchitectureSubscription.vue')
  },
  {
    // 前台閱讀
    path: '/EBookClientReviewSubscription',
    name: 'EBookClientReviewSubscription',
    component: () => import('@/views/php/Subscription/EBookClientReviewSubscription.vue')
  },
  /*---電子書 end---*/
  /*---e評量 Start---*/
  { // 題庫
    path: '/ExamRangeSubscription',
    name: 'ExamRangeSubscription',
    component: () => import('@/views/php/Subscription/ExamRangeSubscription.vue')
  },
  { // 難易度參數設定
    path: '/ExamPaperSettingSubscription',
    name: 'ExamPaperSettingSubscription',
    component: () => import('@/views/php/Subscription/ExamPaperSettingSubscription.vue')
  },
  { // 作答畫面
    path: '/StartExamSubscription',
    name: 'StartExamSubscription',
    component: () => import('@/views/php/Subscription/StartExamSubscription.vue')
  },
  {
    // 成績單
    path: '/UserExamPaperSubscription',
    name: 'UserExamPaperSubscription',
    component: () => import('@/views/php/Subscription/UserExamPaperSubscription.vue')
  },
  {
    // 學習適性分析
    path: '/UserExamPaperRelationLessonSubscription',
    name: 'UserExamPaperRelationLessonSubscription',
    component: () => import('@/views/php/Subscription/UserExamPaperRelationLessonSubscription.vue')
  },
  {
    // 單題測驗
    path: '/SubscribeSingleExam',
    name: 'SubscribeSingleExam',
    component: () => import('@/views/php/Subscription/SubscribeSingleExam.vue')
  },
  {
    // 錯題測驗
    path: '/CorrectUserExamSubscription',
    name: 'CorrectUserExamSubscription',
    component: () => import('@/views/php/Subscription/CorrectUserExamSubscription.vue')
  },
  {
    // 隨堂測驗
    path: '/QuizSubscription',
    name: 'QuizSubscription',
    component: () => import('@/views/php/Subscription/QuizSubscription.vue')
  },
  /*---e評量 end---*/
  /*---解惑平台 Start---*/
  {
    // 解惑平台
    path: '/QuestionListSubscription',
    name: 'QuestionListSubscription',
    component: () => import('@/views/php/Subscription/QuestionListSubscription.vue')
  },
  /*---解惑平台 end---*/
  /*---學習計畫 Start---*/
  {
    // 學習計畫(周)
    path: '/ArrangePlan',
    name: 'ArrangePlan',
    component: () => import('@/views/php/Subscription/ArrangePlan.vue')
  },
  {
    // 學習計畫(月)
    path: '/ArrangeMonthPlan',
    name: 'ArrangeMonthPlan',
    component: () => import('@/views/php/Subscription/ArrangeMonthPlan.vue')
  },
  {
    // 新增學習計畫(課程)
    path: '/AddArrangePlan',
    name: 'AddArrangePlan',
    component: () => import('@/views/php/Subscription/AddArrangePlan.vue')
  },
  {
    // 新增學習計畫(題庫)
    path: '/AddArrangePlanExam',
    name: 'AddArrangePlanExam',
    component: () => import('@/views/php/Subscription/AddArrangePlanExam.vue')
  },
  {
    // 新增學習計畫(電子書)
    path: '/AddArrangePlanEbook',
    name: 'AddArrangePlanEbook',
    component: () => import('@/views/php/Subscription/AddArrangePlanEbook.vue')
  },
  {
    // 批量新增學習計畫
    path: '/AddMultiArrangePlan',
    name: 'AddMultiArrangePlan',
    component: () => import('@/views/php/Subscription/AddMultiArrangePlan.vue')
  },
  /*---學習計畫 end---*/
  /*---追蹤收藏 Start---*/
  {
    // 追蹤收藏
    path: '/MyCollectSubscription',
    name: 'MyCollectSubscription',
    component: () => import('@/views/php/Subscription/MyCollectSubscription.vue')
  },
  /*---追蹤收藏 end---*/
  /*---通知提醒 Start---*/
  {
    path: '/MessageListSubscription',
    name: 'MessageListSubscription',
    component: () => import('@/views/php/Subscription/MessageListSubscription.vue')
  },
  {
    path: '/MessageDetailSubscription',
    name: 'MessageDetailSubscription',
    component: () => import('@/views/php/Subscription/MessageDetailSubscription.vue')
  },
  /*---通知提醒 end---*/
  /*---學習紀錄 Start---*/
  {
    // 課程
    path: '/LearnHistorySubscription',
    name: 'LearnHistorySubscription',
    component: () => import('@/views/php/Subscription/LearnHistorySubscription.vue')
  },
  {
    // 電子書
    path: '/LearnHistoryEbookSubscription',
    name: 'LearnHistoryEbookSubscription',
    component: () => import('@/views/php/Subscription/LearnHistoryEbookSubscription.vue')
  },
  {
    // e評量
    path: '/LearnHistoryExamSubscription',
    name: 'LearnHistoryExamSubscription',
    component: () => import('@/views/php/Subscription/LearnHistoryExamSubscription.vue')
  },
  /*---學習紀錄 end---*/
  /*---個人設定 Start---*/
  {
    // 家長帳號管理
    path: '/UserProfileMainSubscription',
    name: 'UserProfileMainSubscription',
    component: () => import('@/views/php/Subscription/UserProfileMainSubscription.vue')
  },
  {
    // 新增孩子帳號
    path: '/SubmemberRegister',
    name: 'SubmemberRegister',
    component: () => import('@/views/php/Subscription/SubmemberRegister.vue')
  },
  {
    //孩子資料
    path: '/UserProfileSubSubscription',
    name: 'UserProfileSubSubscription',
    component: () => import('@/views/php/Subscription/UserProfileSubSubscription.vue')
  },
  {
    // 孩子帳號管理
    path: '/SubMemberManageSubscription',
    name: 'SubMemberManageSubscription',
    component: () => import('@/views/php/Subscription/SubMemberManageSubscription.vue')
  },
  {
    // 能量 管理
    path: '/UserQuestionPointsSubscriptionPlus',
    name: 'UserQuestionPointsSubscriptionPlus',
    component: () => import('@/views/php/Subscription/UserQuestionPointsSubscriptionPlus.vue')
  },
  {
    // 已獲得能量 
    path: '/UserQuestionPointsSubscriptionCut',
    name: 'UserQuestionPointsSubscriptionCut',
    component: () => import('@/views/php/Subscription/UserQuestionPointsSubscriptionCut.vue')
  },
  // {
  //   // 能量 管理
  //   path: '/UserQuestionPointsSubSubscription',
  //   name: 'UserQuestionPointsSubSubscription',
  //   component: () => import('@/views/php/Subscription/UserQuestionPointsSubSubscription.vue')
  // },
  {
    // 訂閱紀錄 
    path: '/HistoryOrderList',
    name: 'HistoryOrderList',
    component: () => import('@/views/php/Subscription/HistoryOrderList.vue')
  },
  /*---個人設定 end---*/
  /*---學習紀錄 Start---*/
  {
    // 課程
    path: '/LearningMapSubscription',
    name: 'LearningMapSubscription',
    component: () => import('@/views/php/Subscription/LearningMapSubscription.vue')
  },
  /*---學習紀錄 end---*/
  /*---學習雷達圖 Start---*/
  {
    // e評量
    path: '/LearningRader',
    name: 'LearningRader',
    component: () => import('@/views/php/Subscription/LearningRader.vue')
  },
  /*---學習雷達圖 end---*/
  {
    // 金流 綁定信用卡
    path: '/HistoryBindCard',
    name: 'HistoryBindCard',
    component: () => import('@/views/php/Subscription/HistoryBindCard.vue')
  },
  {
    // 訂閱方案
    path: '/SubscribePlan',
    name: 'SubscribePlan',
    component: () => import('@/views/php/Subscription/SubscribePlan.vue')
  },
  {
    // 訂閱付款
    path: '/SubscribePayment',
    name: 'SubscribePayment',
    component: () => import('@/views/php/Subscription/SubscribePayment.vue')
  },
  {
    // iPad版註冊流程 - 新增孩子帳號
    path: '/PadSubmemberRegister',
    name: 'PadSubmemberRegister',
    component: () => import('@/views/php/Subscription/PadSubmemberRegister.vue')
  },
  {
    // iPad版 - 每日簽到
    path: '/DailyCheckin',
    name: 'DailyCheckin',
    component: () => import('@/views/php/Subscription/DailyCheckin.vue')
  },
  {
    // iPad版 - 使用限制
    path: '/UseLimit',
    name: 'UseLimit',
    component: () => import('@/views/php/Subscription/UseLimit.vue')
  },
];
    
export default Subscription;